var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsModalGreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 169,
    viewBox: "0 0 256 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_60390)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 169,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.368 128.936L63.0908 167.354L59.1271 156.686L152.741 118.873",
    fill: "#E9F3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.368 128.936L63.0908 167.354L59.1271 156.686L152.741 118.873",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.99 146.095C261.482 125.322 252.49 94.1478 251.979 92.4857C244.866 69.2952 220.426 46.6037 192.634 51.4652C163.112 56.6296 146 90.0463 152.334 117.657C157.108 138.462 175.239 156.165 197.594 159.254C200.534 159.662 223.127 162.405 239.99 146.095Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75 139.635C251.691 122.298 244.185 96.2738 243.758 94.8887C237.821 75.5322 217.42 56.5893 194.228 60.6639C169.585 64.9722 155.303 92.8695 160.589 115.914C164.575 133.28 179.708 148.054 198.371 150.634C200.807 150.96 219.667 153.248 233.75 139.635Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.891 107.2C230.891 107.2 200.978 138.164 171.836 102.937C171.836 102.937 204.104 72.6423 230.891 107.2Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.66 114.801C206.007 115.187 210.653 111.192 211.037 105.878C211.42 100.563 207.396 95.9423 202.049 95.5563C196.701 95.1703 192.055 99.1655 191.672 104.48C191.288 109.794 195.312 114.415 200.66 114.801Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5651 36.4423L69.3573 8.10753C62.6097 4.75012 54.6846 3.67531 47.0189 5.58301C35.4289 8.45841 24.6767 18.0523 23.0906 31.0683C21.2096 46.485 32.9639 60.4576 47.0189 64.0791C64.6325 68.6184 83.7799 56.3615 86.9018 40.3981C87.1563 39.0966 87.3025 37.7767 87.3386 36.4516L54.5651 36.4423Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1131 31.9905C101.511 20.3891 94.7672 10.0787 93.948 8.86535C91.8911 5.83588 89.3271 3.17593 86.3662 1L66.8306 26.3689L99.1131 31.9905Z",
    fill: "#E9F3FB",
    stroke: "#1494FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.631 18.1466C190.251 15.1242 186.322 14.5054 183.324 15.298C180.042 16.1654 176.998 18.9536 176.485 22.8471C175.933 27.0248 178.467 31.1715 182.407 32.5323C187.074 34.144 191.881 31.2153 193.618 27.2628C194.768 24.6454 194.845 20.9589 192.631 18.1466Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.125 17.4436C131.406 15.0929 128.568 14.6116 126.403 15.2281C124.033 15.9027 121.835 18.0713 121.464 21.0996C121.066 24.3489 122.896 27.5741 125.741 28.6326C129.111 29.8861 132.583 27.6082 133.838 24.534C134.669 22.4983 134.724 19.631 133.125 17.4436Z",
    fill: "#EFE8FD",
    stroke: "#BFA1F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2416 148.959L37.865 101.144L55.7181 135.283L94.1778 78.866L119.433 111.903L148.31 55.8819L156.223 61.0683L159.807 32.7383L135.285 44.7443L142.122 52.0263L117.579 92.7347L95.1161 58.9512L56.6659 108.14L37.8981 75.743L1.87248 126.072L14.2416 148.959Z",
    fill: "#EBF9F3",
    stroke: "#62D0A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_60390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsModalGreet);
export default __webpack_public_path__ + "static/media/insightsModalGreet.3766c7f411835e244c5b29ec0d86c840.svg";
export { ForwardRef as ReactComponent };